{
  "basicTerms": {
    "selectedOfTotal": "{selected}/{total}개 선택됨",
    "search": "검색",
    "summary": "요약",
    "insights": "인사이트",
    "help": "도움말",
    "expand": "펼치기",
    "collapse": "접기",
    "menu": "메뉴",
    "account": "계정",
    "logout": "로그아웃",
    "signIn": "로그인",
    "days": "일 | 일",
    "phone": "전화번호",
    "subscribers": "수신자 | 수신자",
    "favorites": "즐겨찾기 | 즐겨찾기",
    "others": "기타 | 기타",
    "yes": "예",
    "no": "아니요",
    "locations": "위치 | 위치",
    "active": "활성",
    "inactive": "비활성",
    "all": "전체",
    "view": "보기",
    "language": "언어",
    "required": "필수",
    "timezone": "시간대",
    "new": "신규",
    "open": "열림",
    "close": "닫기",
    "closed": "닫힘",
    "occupied": "사용 중",
    "reserved": "예약됨",
    "enabled": "사용",
    "disabled": "사용 안 함",
    "enable": "사용",
    "disable": "사용 안 함",
    "print": "인쇄",
    "download": "다운로드",
    "zoomIn": "확대",
    "zoomOut": "축소",
    "previous": "이전",
    "next": "다음",
    "version": "버전",
    "setup": "설정",
    "caution": "주의",
    "notes": "메모 | 메모",
    "add": "추가",
    "remove": "삭제",
    "duration": "소요 시간",
    "link": "연결",
    "unlink": "연결 해제",
    "to": "종료",
    "success": "성공",
    "error": "오류",
    "info": "정보",
    "warning": "경고",
    "time": "시간",
    "saved": "저장됨",
    "forms": "양식 | 양식",
    "is": "은(는)",
    "only": "만",
    "saving": "저장 중",
    "text": "텍스트",
    "zip": "zip",
    "spreadsheet": "스프레드시트",
    "image": "이미지",
    "cloning": "복제 중",
    "clone": "복제",
    "added": "추가됨",
    "removed": "삭제됨",
    "planned": "예정됨",
    "unplanned": "예정되지 않음",
    "checkedIn": "체크인됨",
    "checkedOut": "체크아웃됨",
    "more": "더 보기",
    "okay": "확인",
    "reschedule": "일정 변경",
    "results": "결과 | 결과",
    "none": "없음",
    "pages": "페이지 | 페이지",
    "pageOfTotal": "{current}/{total} 페이지",
    "of": "/",
    "default": "기본값",
    "soon": "곧",
    "grid": "그리드",
    "list": "목록",
    "booked": "예약됨",
    "arrivals": "도착 | 도착",
    "early": "조기",
    "late": "지각",
    "onTime": "정시",
    "area": "구역 | 구역",
    "spot": "스팟",
    "single": "단일",
    "multiple": "복수",
    "filter": "필터",
    "board": "보드",
    "at": "-",
    "from": "시작",
    "recent": "최근",
    "delivered": "전달됨",
    "sent": "보냄",
    "create": "만들기",
    "tasks": "작업 | 작업",
    "emails": "이메일 | 이메일",
    "passwords": "비밀번호 | 비밀번호",
    "limits": "한도",
    "assignee": "담당자",
    "comment": "댓글",
    "issue": "문제",
    "urgent": "긴급",
    "retry": "다시 시도",
    "custom": "사용자 지정",
    "na": "해당 없음"
  },
  "phrases": {
    "copyToClipboard": "클립보드에 복사",
    "copiedToClipboard": "클립보드에 복사됨",
    "warehouseAddress": "창고 주소",
    "cloneSchedule": "일정 복제",
    "open24Hours": "24시간 운영",
    "featureEnabled": "기능 사용 중",
    "featureDisabled": "기능 사용 안 함",
    "learnMore": "자세히 알아보기",
    "minuteLabel": "{minutes}분",
    "minuteLabelFull": "{minutes}분",
    "thisActionCannotBeUndone": "이 작업은 되돌릴 수 없습니다",
    "areYouSure": "계속하시겠습니까?",
    "unknownUser": "알 수 없는 사용자",
    "leaveWithoutSaving": "저장하지 않고 나가기",
    "learnHowItWorks": "작동 방식 알아보기",
    "allFields": "모든 필드",
    "selectColumns": "열 선택",
    "selectedColumns": "선택한 열",
    "addFiles": "파일 추가 | 파일 추가",
    "tasks": "작업 없음 | 작업 {count}개 | 작업 {count}개",
    "driversSelfCheckin": "운전자 셀프 체크인",
    "addReferenceNumber": "참조 번호 추가",
    "myAccount": "내 계정"
  },
  "messages": {
    "theConfirmationFieldDoesNotSupportPasting": "확인 필드에는 붙여넣기를 할 수 없습니다",
    "youMayHaveUnsavedChangesAreYouSureYouWantToLeaveThisPage": "저장하지 않은 변경 사항이 있을 수 있습니다. 이 페이지에서 나가시겠습니까?",
    "browserDoesNotSupportCopyFunction": "브라우저가 복사 기능을 지원하지 않습니다",
    "permissionToAccessClipboardWasDeniedToEnableAccessUpdateYourBrowserSettings": "클립보드 접근 권한이 거부되었습니다. 접근을 허용하려면 브라우저 설정을 변경하세요.",
    "alternativelyYouCanManuallyCopy": "또는 직접 복사할 수 있습니다",
    "areYouSureYouWantToLeaveYouMayHaveUnsavedChanges": "나가시겠습니까? 저장하지 않은 변경 사항이 있을 수 있습니다.",
    "noResultsFound": "결과가 없습니다",
    "maximumOfReferenceNumbersAllowedCountRemoved": "참조 번호는 최대 {maxItems}개까지 허용됩니다. {removedCount}개가 삭제되었습니다"
  },
  "fileFormats": {
    "jpeg": "jpeg",
    "jpg": "jpg",
    "png": "png",
    "webp": "webp",
    "pdf": "pdf"
  },
  "specialtyTerms": {
    "opendock": "Opendock",
    "warehouses": "창고 | 창고",
    "carrierContacts": "운송사 담당자 | 운송사 담당자",
    "loadTypes": "화물 유형 | 화물 유형",
    "docks": "도크 | 도크",
    "appointments": "예약 | 예약",
    "users": "사용자 | 사용자",
    "organizations": "조직 | 조직",
    "orgs": "조직 | 조직",
    "companies": "회사 | 회사",
    "referenceNumber": "참조 번호",
    "refNumber": "참조 번호",
    "status": "상태",
    "orgLoadTypes": "조직 화물 유형",
    "schedulingPortal": "예약 포털",
    "customFields": "사용자 지정 필드 | 사용자 지정 필드",
    "interval": "간격",
    "drivers": "운전자 | 운전자",
    "carriers": "운송사 | 운송사",
    "tags": "태그 | 태그",
    "yardManagement": "야드 관리",
    "carrier": "운송사 | 운송사",
    "assets": "자산 | 자산",
    "tvMode": "TV 모드",
    "gridView": "그리드 보기",
    "listView": "목록 보기",
    "gateManagement": "게이트 관리",
    "selfCheckIn": "셀프 체크인",
    "gateFeed": "게이트 피드"
  },
  "appointmentStatuses": {
    "NoShow": "노쇼",
    "Cancelled": "취소됨",
    "Requested": "요청됨",
    "Scheduled": "예약됨",
    "Arrived": "도착함",
    "InProgress": "진행 중",
    "Completed": "완료됨",
    "Reserves": "예비 예약"
  },
  "appointmentTypes": {
    "standard": "표준",
    "reserved": "예비 예약됨",
    "reserve": "예비 예약"
  },
  "appointmentCreatorTypes": {
    "warehouseUser": "창고 사용자",
    "carrier": "운송사"
  },
  "roles": {
    "base": "기본",
    "carrier": "운송사",
    "carrierAdmin": "운송사 관리자",
    "spectator": "관람자",
    "attendant": "담당자",
    "operator": "운영자",
    "admin": "관리자",
    "owner": "소유자",
    "internal": "내부",
    "god": "최고 관리자"
  },
  "weekdays": {
    "sunday": "일요일",
    "monday": "월요일",
    "tuesday": "화요일",
    "wednesday": "수요일",
    "thursday": "목요일",
    "friday": "금요일",
    "saturday": "토요일"
  },
  "weekdaysAbbr": {
    "sun": "일",
    "mon": "월",
    "tue": "화",
    "wed": "수",
    "thu": "목",
    "fri": "금",
    "sat": "토"
  },
  "buttons": {
    "nevermind": "취소",
    "select": "선택",
    "confirm": "확인",
    "next": "다음",
    "previous": "이전",
    "create": "만들기",
    "edit": "편집",
    "save": "저장",
    "send": "보내기",
    "yesDelete": "예, 삭제합니다",
    "skipCreation": "만들기 건너뛰기",
    "cancel": "취소",
    "export": "내보내기",
    "saveChanges": "변경 사항 저장",
    "exportData": "데이터 내보내기",
    "resetToDefault": "기본값으로 재설정"
  },
  "tooltips": {
    "notAvailable": "사용할 수 없음",
    "notAvailableForUserRole": "사용자 역할에서 사용할 수 없습니다."
  },
  "errors": {
    "unkownError": "알 수 없는 오류가 발생했습니다.",
    "thisFieldIsRequired": "필수 입력 항목입니다",
    "passwordDoesNotMeetRequirements": "비밀번호가 요구 사항을 충족하지 않습니다",
    "emailMustBeValid": "유효한 이메일이어야 합니다",
    "pleaseEnterAValidPhoneNumber": "유효한 전화번호를 입력하세요",
    "pleaseEnterAValidUrl": "유효한 URL을 입력하세요",
    "invalidHour": "잘못된 시간",
    "invalidMinute": "잘못된 분",
    "pleaseSelectAmOrPm": "AM 또는 PM을 선택하세요",
    "pleaseEnterACompleteDateAndTime": "날짜와 시간을 모두 입력하세요",
    "mustBeANumber": "숫자여야 합니다",
    "mustBeAPositiveInteger": "양의 정수여야 합니다",
    "mustBeAWholeNumber": "정수여야 합니다",
    "isNotAValidNumber": "은(는) 유효한 숫자가 아닙니다",
    "invalidUuid": "잘못된 UUID",
    "dateMustNotBeInThePast": "날짜는 과거일 수 없습니다",
    "mustBeWithin24HoursOfStartTime": "시작 시간으로부터 24시간 이내여야 합니다",
    "pleaseSelectAtLeast": "{itemName}을(를) {requiredCount}개 이상 선택하세요 | {itemName}을(를) {requiredCount}개 이상 선택하세요",
    "cannotSelectMoreThan": "{itemName}은(는) {limit}개를 초과하여 선택할 수 없습니다 | {itemName}은(는) {limit}개를 초과하여 선택할 수 없습니다",
    "fieldMustEqual": "필드 값은 {value}와(과) 같아야 합니다",
    "mustBeXCharacters": "{length}자여야 합니다 | {length}자여야 합니다",
    "mustBeAtLeastXCharacters": "{min}자 이상이어야 합니다 | {min}자 이상이어야 합니다",
    "mustBeAtMostXCharacters": "{max}자 이하여야 합니다 | {max}자 이하여야 합니다",
    "mustBeBetweenXAndYCharactersLong": "{min}자에서 {max}자 사이여야 합니다",
    "mustBeNumberBetweenXAndY": "{min}에서 {max} 사이의 숫자여야 합니다",
    "mustBeNumberGreaterThan": "{min} 이상의 숫자여야 합니다",
    "mustBeNumberLessThan": "{max} 미만의 숫자여야 합니다",
    "mustHaveAtLeast8Characters": "8자 이상이어야 합니다",
    "mustContainUpperCaseAndLowerCase": "대문자와 소문자를 포함해야 합니다",
    "mustContainAtLeastOneLetter": "문자를 하나 이상 포함해야 합니다",
    "mustContainAtLeastOneSpecialCharacter": "특수 문자를 하나 이상 포함해야 합니다",
    "mustContainAtLeastOneNumber": "숫자를 하나 이상 포함해야 합니다",
    "atLeastOneReferenceNumberIsRequired": "{refNumberDisplayName}이(가) 하나 이상 필요합니다",
    "mustBeAValidNumber": "유효한 숫자여야 합니다"
  },
  "warehouseAmenities": {
    "lumperServices": "하역 대행(럼퍼) 서비스",
    "overnightParking": "야간 주차",
    "driversRestroom": "운전자 화장실",
    "freeWiFi": "무료 Wi-Fi"
  },
  "warehousePPERequirements": {
    "safetyBoots": "안전화",
    "safetyGlasses": "보안경",
    "gloves": "장갑",
    "hardHat": "안전모",
    "faceMask": "마스크",
    "noSmoking": "금연",
    "longPants": "긴바지",
    "longSleeves": "긴소매",
    "highVisibilityVest": "고시인성 조끼",
    "hairAndBeardNet": "헤어 및 수염 망"
  },
  "auditLog": {
    "header": "감사 로그",
    "viewAuditLog": "감사 로그 보기",
    "noAuditLogEvents": "감사 로그 이벤트 없음",
    "timelineForAllUpdatesMadeToThis": "다음 항목의 모든 업데이트 타임라인:",
    "hasTheWords": "포함 단어",
    "eventsFromDate": "이벤트 시작 날짜",
    "searchEvents": "이벤트 검색",
    "by": "작성자:",
    "appointmentUpdatesTimeline": "예약 업데이트 타임라인:",
    "moreUpdates": "업데이트 {count}개 더 보기",
    "emailSubscribersUpdated": "이메일 수신자 업데이트됨",
    "detailsUpdated": "세부 정보 업데이트됨",
    "recurrenceCreated": "반복 일정 생성됨",
    "recurrenceDeleted": "반복 일정 삭제됨",
    "rescheduled": "{label} 일정 변경됨",
    "etaUpdated": "ETA 업데이트됨",
    "emailNotifications": "이메일 알림",
    "carrierContactUpdated": "운송사 담당자 업데이트됨",
    "reserveTransferred": "예비 예약 이전됨",
    "tagsUpdated": "태그 업데이트됨",
    "scheduled": "{label} 예약됨",
    "statusUpdated": "상태 업데이트됨",
    "timeUpdated": "{arrived} 시간 업데이트됨",
    "dwellTimeUpdated": "체류 시간 업데이트됨",
    "everyXAtXUntilX": "{endDate}까지 매주 {weekDays} {'@'} {endTime}",
    "opendockTeam": "Opendock 팀",
    "unknownUser": "알 수 없는 사용자",
    "deleted": "삭제됨",
    "hasBeenCleared": "이(가) 지워졌습니다",
    "actionUpdated": "업데이트됨",
    "actionCreated": "생성됨",
    "actionDeleted": "삭제됨",
    "noAction": "작업 없음",
    "emptyValue": "빈 값"
  },
  "timeline": {
    "createdTheTask": "작업을 생성함",
    "startedTheTask": "작업을 시작함",
    "blockedTheTask": "작업을 차단함",
    "unblockedTheTask": "작업 차단을 해제함",
    "completedTheTask": "작업을 완료함",
    "cancelledTheTask": "작업을 취소함",
    "cancelledTheReserve": "예비 예약을 취소함",
    "cancelledTheReservationForSpot": "이 작업의 {areaName} - {spotCode} 예약을 취소함",
    "reservedSpotForThisTask": "이 작업을 위해 {areaName} - {spotCode}을(를) 예약함",
    "reservedTheSpot": "스팟을 예약함",
    "reason": "사유: {reason}",
    "addedA": "추가함:",
    "reportedAn": "보고함:",
    "clearedThe": "해제함:",
    "flaggedTheTask": "작업에 플래그를 지정함",
    "flaggedTheTaskAs": "작업에 플래그 지정:",
    "unflaggedTheTask": "작업의 플래그를 해제함",
    "unflaggedTheTaskAs": "작업의 플래그 해제:",
    "updatedTheTask": "작업을 업데이트함",
    "removedTask": "작업을 삭제함",
    "attachments": "첨부 파일",
    "confirmedTheLocation": "위치를 확인함",
    "reportedAsMissing": "분실로 보고함",
    "noActivityYet": "아직 활동 없음",
    "noAssignee": "담당자 없음",
    "failedToFetchYardTaskTimeline": "야드 작업 타임라인을 가져오지 못했습니다",
    "failedToCreateComment": "댓글을 작성하지 못했습니다"
  },
  "yardSpotStatusDialog": {
    "headers": {
      "actionThisSpot": "이 스팟을 {action}하시겠습니까?"
    },
    "dropDownItems": {
      "cleaning": "청소 중",
      "underMaintenance": "유지 보수 중",
      "blockedByEquipment": "장비로 막힘",
      "safetyInspection": "안전 점검",
      "routineInspection": "정기 점검",
      "reserved": "예약됨",
      "repairsNeeded": "수리 필요",
      "damage": "손상"
    },
    "labels": {
      "reason": "사유",
      "additionalNotes": "추가 메모"
    },
    "placeholders": {
      "selectAReason": "사유 선택",
      "enterAdditionalNotes": "추가 메모 입력"
    },
    "messages": {
      "thisSpotWillRemainUnavailable": "이 스팟은 다시 열림으로 설정될 때까지 자산 배정에 사용할 수 없습니다.",
      "thisDoorWillBeSetAsOpen": "이 도어는 열림으로 설정되며 다시 자산 배정에 사용할 수 있게 됩니다.",
      "assetInTransitClosingWillBlockMove": "자산 {assetCode}이(가) 현재 이 스팟으로 이동 중입니다. 스팟을 닫으면 이동을 완료할 수 없습니다."
    }
  },
  "tasks": {
    "presenter": {
      "unassigned": "미배정",
      "noDueDate": "마감일 없음",
      "fromAnySpot": "모든 스팟에서",
      "toAnySpot": "모든 스팟으로",
      "anyAsset": "모든 자산",
      "types": {
        "move": "이동"
      },
      "status": {
        "toDo": "할 일",
        "inProgress": "진행 중",
        "completed": "완료됨",
        "canceled": "취소됨"
      },
      "issue": "문제",
      "relatedEntity": {
        "spotArea": "구역",
        "spot": "스팟",
        "asset": "자산"
      }
    }
  },
  "readyForPickupNotificationDialog": {
    "title": "픽업 준비 완료 알림",
    "messages": {
      "body": "다음 담당자에게 자산 {assetContainerCode}이(가) {warehouseName}에서 픽업 준비가 완료되었음을 알리는 이메일을 보냅니다.",
      "notificationSent": "알림을 보냈습니다.",
      "notificationFailed": "알림을 보내지 못했습니다. 다시 시도해 주세요."
    },
    "labels": {
      "notifyTheseContacts": "알릴 담당자:",
      "suggestedContacts": "추천 담당자:"
    },
    "buttons": {
      "skipNotification": "알림 건너뛰기"
    }
  }
}
